import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatAutocompleteModule,
         MatButtonModule,
         MatButtonToggleModule,
         MatCardModule,
         MatCheckboxModule,
         MatChipsModule,
         MatDatepickerModule,
         MatDialogModule,
         MatExpansionModule,
         MatGridListModule,
         MatIconModule,
         MatInputModule,
         MatListModule,
         MatMenuModule,
         MatNativeDateModule,
         MatPaginatorModule,
         MatProgressBarModule,
         MatProgressSpinnerModule,
         MatRadioModule,
         MatRippleModule,
         MatSelectModule,
         MatSidenavModule,
         MatSliderModule,
         MatSlideToggleModule,
         MatSnackBarModule,
         MatSortModule,
         MatTableModule,
         MatTabsModule,
         MatToolbarModule,
         MatTooltipModule,
         MatStepperModule,
         MatBadgeModule,
         MatDialogRef} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberPickerComponent } from './components/number-picker/number-picker.component';
import { BlockUIComponent } from './components/block-ui/block-ui.component';
import { TypeAgentDialogComponent } from './components/type-agent-dialog/type-agent-dialog.component';
import {CdkTableModule} from '@angular/cdk/table';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PreviewDialogComponent } from './components/preview-dialog/preview-dialog.component';
import { VerticalMenuComponent } from '../theme/components/menu/vertical-menu/vertical-menu.component';
import { UploadDialogComponent } from './components/upload-dialog/upload-dialog.component';
import { MultiSelectRoleComponent } from './components/multi-select-role/multi-select-role.component';
import { MultiSelectModulesComponent } from './components/multi-select-modules/multi-select-modules.component';
import { SelectInstitutionComponent } from './components/select-institution/select-institution.component';
import { SelectStudyPlanComponent } from './components/select-study-plan/select-study-plan.component';
import { SelectBusinessComponent } from './components/select-business/select-business.component';
import { SelectModuleComponent } from './components/select-module/select-module.component';
import { PermissionDialogComponent } from './components/permission-dialog/permission-dialog.component';
import { ConfirmPayDialogComponent } from './components/confirm-pay-dialog/confirm-pay-dialog.component';
import { OxxoPayDialogComponent } from './components/oxxo-pay-dialog/oxxo-pay-dialog.component';
import { TicketDialogComponent } from './components/ticket-dialog/ticket-dialog.component';
import { ConektaSubscriptionDialogComponent } from './components/conekta-subscription-dialog/conekta-subscription-dialog.component';
import { RejectionMotivesComponent } from './components/rejection-motives/rejection-motives.component';
import { ConfirmUpdateDocumentDialogComponent } from './components/confirm-update-document-dialog/confirm-update-document-dialog.component';
import { VideoPlayerDialogComponent } from './components/video-player-dialog/video-player-dialog.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { CouponDialogComponent } from './components/coupon-dialog/coupon-dialog.component';
import { ProgressBarBlockUiComponent } from './components/progress-bar-block-ui/progress-bar-block-ui.component';
import { HasCustomPermissionDirective } from './directives/has-custom-permission.directive';
import { HasNotCustomPermissionDirective } from './directives/has-not-custom-permission.directive';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
   url: '/api/uploadFile',
   maxFilesize: 50,
  //  acceptedFiles: 'image/*'
 };
 

@NgModule({
  imports: [
    CdkTableModule,
    CommonModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatBadgeModule,
    FormsModule,
    ReactiveFormsModule,
    DropzoneModule
  ],
  exports: [
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatBadgeModule,
    ReactiveFormsModule,
    FormsModule,
    NumberPickerComponent,
    TypeAgentDialogComponent,
    CouponDialogComponent,
    BlockUIComponent,
    NumbersOnlyDirective,
    DropzoneModule,
    NgxMatSelectSearchModule,
    PreviewDialogComponent,
    SelectInstitutionComponent,
    SelectBusinessComponent,
    SelectStudyPlanComponent,
    SelectModuleComponent,
    PermissionDialogComponent,
    ConfirmPayDialogComponent,
    TicketDialogComponent,
    ProgressBarBlockUiComponent,
    HasCustomPermissionDirective,
    HasNotCustomPermissionDirective,
  ],
  declarations: [
    NumberPickerComponent,
    TypeAgentDialogComponent,
    CouponDialogComponent,
    BlockUIComponent,
    NumbersOnlyDirective,
    PreviewDialogComponent,
    // VerticalMenuComponent,
    UploadDialogComponent,
    MultiSelectRoleComponent,
    MultiSelectModulesComponent,
    SelectInstitutionComponent,
    SelectBusinessComponent,
    SelectStudyPlanComponent,
    SelectModuleComponent,
    PermissionDialogComponent,
    ConfirmPayDialogComponent,
    OxxoPayDialogComponent,
    ConektaSubscriptionDialogComponent,
    TicketDialogComponent,
    RejectionMotivesComponent,
    ConfirmUpdateDocumentDialogComponent,
    VideoPlayerDialogComponent,
    SafeUrlPipe,
    ProgressBarBlockUiComponent,
    HasCustomPermissionDirective,
    HasNotCustomPermissionDirective,
  ],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
    // {
    //   provide: MatDialogRef,
    //   useValue: {}
    // },
    // { provide: MatPaginatorIntl, useClass: CustomPaginator}
  ],
  entryComponents: [
    // UploadDialogComponent
    PermissionDialogComponent,
    ConfirmPayDialogComponent,
    OxxoPayDialogComponent,
    ConektaSubscriptionDialogComponent,
    TicketDialogComponent,
    RejectionMotivesComponent,
    ConfirmUpdateDocumentDialogComponent,
    VideoPlayerDialogComponent
  ],
})
export class SharedModule { }
